module.exports = __webpack_public_path__ + "static/img/top1_i6_nav.e8d86650.png";